import { Typography, Grid } from '@mui/material';
import injupemplogogobierno from '../img/injupemplogogobierno.png'

export default function DashDefault({ nombre, apellido, modulo }) {

    return (

        <Grid container direction="column" alignItems="center" marginTop={5}>
            <Grid item>
                <Typography variant="h3">¡Bienvenido {nombre} {apellido}!</Typography>
            </Grid>
            <Grid container item justifyContent="center">
                <img src={injupemplogogobierno} alt="Logo" style={{ width: '80vw' }} />
            </Grid>
        </Grid>
    );
}